import get from 'lodash/get';
import uniq from 'lodash/uniq';
import createFacet from './createFacet';
import incCount from './helpers/incCount';

export default function createArrayFacet(options) {
  const { stateKey, itemKey, itemSubKey } = options;
  return createFacet(
    {
      // state, initialValue and prepare are defined in createFacet.

      // The reducer for the facet values.
      reducer(facetValues, item) {
        // Step 1: collect and deduplicate all the values.
        const itemValues = get(item, itemKey);
        if (!itemValues) return facetValues;
        const uniqueValues = uniq(
          itemSubKey
            ? itemValues.map((value) => get(value, itemSubKey))
            : itemValues
        );
        // Step 2: increment the counter for all the values.
        return uniqueValues.reduce(
          (acc, value) => incCount(acc, value),
          facetValues
        );
      },

      matches: ({ [stateKey]: filterValues }) => {
        if (!filterValues?.length) return () => true;
        return (item) => {
          const values = get(item, itemKey);
          if (!values?.length) return false;
          if (itemSubKey) {
            return values.some((value) =>
              filterValues.includes(get(value, itemSubKey))
            );
          }
          return filterValues.some((filterValue) =>
            values.includes(filterValue)
          );
        };
      },
    },

    options
  );
}
